interface SmsIdentityState {
    state?: string;
}

interface SmsSource {
    sms?: {
        externalReference?: string | null;
    } | null;
    [key: string]: unknown;
}

interface SmsSubscriptionItem {
    source?: SmsSource | null;
}

interface SmsSubscriptionResponse {
    items?: SmsSubscriptionItem[];
}

export const getSmsExternalReference = (source?: SmsSource | null) => source?.sms?.externalReference;

export const isSmsAccountUser = ({
    identityResponse,
    subscriptionsResponse,
}: {
    identityResponse?: SmsIdentityState;
    subscriptionsResponse?: SmsSubscriptionResponse;
}) =>
    identityResponse?.state === 'ACCOUNT' &&
    (subscriptionsResponse?.items ?? []).some((item) => Boolean(getSmsExternalReference(item.source)));
